import * as yup from 'yup'

import { toLocalDate } from '../../../../utils/date'

export const validationSchema = (isEditMode = false) =>
  yup.object().shape({
    package: yup.string().required('Package is required'),
    startDate: yup
      .date()
      .required('Start date is required')
      .test(
        'is-future',
        'Start date cannot be in the past',
        function (value: Date) {
          return (
            isEditMode ||
            !value ||
            value?.getTime() >= toLocalDate(new Date()).getTime()
          )
        }
      ),
    endDate: yup
      .date()
      .nullable()
      .optional()
      .min(yup.ref('startDate'), 'End date must be after start date'),
  })
